"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/DataLoader.css");
var reactstrap_2 = require("reactstrap");
var Util_1 = require("../Services/Util");
var AuthenticationService_1 = require("../Services/AuthenticationService");
var DataLoader = /** @class */ (function (_super) {
    __extends(DataLoader, _super);
    function DataLoader(props) {
        var _this = _super.call(this, props) || this;
        _this.finishedLoad = function () {
            return _this.state.itemsLoaded == _this.itemsToLoad && _this.props.isConnected;
        };
        _this.state = {
            itemsLoaded: 0,
            finishedLoading: false,
            loadingDescription: "..."
        };
        //plus one to account for establishing a websocket connection as part of loading
        _this.itemsToLoad = _this.props.dataToLoad.length;
        return _this;
    }
    DataLoader.prototype.componentDidMount = function () {
        var _this = this;
        this.props.dataToLoad.map(function (data) {
            setTimeout(function () {
                Util_1.getJson(data.endpoint, undefined, true, new Util_1.UserRequestHeaders(__assign(__assign({}, AuthenticationService_1.Auth.getUser()), { Location: _this.props.location })))
                    .then(function (response) {
                    var value = JSON.parse(response);
                    _this.setState({ itemsLoaded: _this.state.itemsLoaded + 1 });
                    _this.props.onUpdate(data.key, value);
                }).catch(function (reason) { return console.error("Error loading " + data.key + ". With reason: " + reason); });
            }, 1200);
        });
    };
    DataLoader.prototype.componentDidUpdate = function () {
        var _this = this;
        if (this.state.finishedLoading) {
            setTimeout(function () {
                _this.props.onComplete();
            }, 100);
        }
        else {
            if (this.finishedLoad()) {
                setTimeout(function () {
                    _this.setState({
                        finishedLoading: true
                    });
                }, 1000);
            }
        }
        if (this.state.itemsLoaded != this.itemsToLoad) {
            if (this.state.loadingDescription != this.props.resources.LoadingComponents) {
                this.setState({
                    loadingDescription: this.props.resources.LoadingComponents
                });
            }
        }
        else if (!this.props.isConnected) {
            if (this.state.loadingDescription != this.props.resources.EstablishingASecureConnection) {
                this.setState({
                    loadingDescription: this.props.resources.EstablishingASecureConnection
                });
            }
        }
        else {
            if (this.state.loadingDescription != "...") {
                this.setState({
                    loadingDescription: "..."
                });
            }
        }
    };
    DataLoader.prototype.render = function () {
        return (React.createElement(reactstrap_2.Fade, { in: !this.state.finishedLoading, timeout: 300 },
            React.createElement("div", { className: "center" },
                React.createElement("img", { className: "data-loader-image", src: this.props.siteLogo, alt: "VeriLite" }),
                React.createElement("div", { className: "progress-container" },
                    React.createElement(reactstrap_1.Progress, { className: "dataloader-progress-bar", bar: true, animated: !this.finishedLoad(), color: this.finishedLoad() ? "success" : "primary", value: this.state.itemsLoaded + Number(this.props.isConnected), max: this.props.dataToLoad.length + 1 })),
                React.createElement("div", null, this.state.loadingDescription))));
    };
    return DataLoader;
}(React.Component));
exports.DataLoader = DataLoader;
//# sourceMappingURL=DataLoader.js.map